// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AlertBannerNotificationInteractViewEvent
 */
export var AlertBannerNotificationInteractView = function (_a) {
    var screen = _a.screen, state = _a.state, type = _a.type, adversityType = _a.adversityType;
    return ({
        name: "AlertBannerNotification Interact View",
        parameters: {
            cdf_entity: "AlertBannerNotification",
            cdf_action: "Interact",
            screen: screen !== undefined && screen !== null ? screen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            state: state !== undefined && state !== null ? state.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            adversity_type: adversityType !== undefined && adversityType !== null ? adversityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AlertBannerNotificationInteractTapEvent
 */
export var AlertBannerNotificationInteractTap = function (_a) {
    var screen = _a.screen, state = _a.state, type = _a.type, adversityType = _a.adversityType;
    return ({
        name: "AlertBannerNotification Interact Tap",
        parameters: {
            cdf_entity: "AlertBannerNotification",
            cdf_action: "Interact",
            screen: screen !== undefined && screen !== null ? screen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            state: state !== undefined && state !== null ? state.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            adversity_type: adversityType !== undefined && adversityType !== null ? adversityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
